<template>
  <b-container>
    <b-row id="content" align-h="between">
      <b-col cols="12">
        <div class="text-center">
          <div class="mb-3">
            <slot name="icon">
              <b-icon-exclamation-triangle
                variant="info"
                class="icon"
              ></b-icon-exclamation-triangle>
            </slot>
          </div>
          <h2 :class="{ 'mb-4': !response, 'mb-3': response }">
            {{ $t(message) }}
          </h2>
          <div v-if="response" class="text-black mb-5">
            {{ response }}
          </div>
          <div v-if="action" class="text-secondary">
            {{ $t(action) }}
          </div>
          <slot v-if="!noButton" name="button">
            <b-button class="mt-5" variant="primary" @click="handleClick">{{
              $t("button.continue")
            }}</b-button>
          </slot>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BIconExclamationTriangle } from "bootstrap-vue";

export default {
  name: "VerificationResult",
  components: { BIconExclamationTriangle },
  props: {
    message: {
      type: String,
      default: "",
    },
    response: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: "",
    },
    noButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.icon {
  min-width: 150px;
  min-height: 150px;
}
</style>